<template>
  <section class="page-title-area">
    <h2 class="page-title">
      <slot />
    </h2>
    <div style="display:flex;">
      <div
        v-if="!$store.state.isSidebarHidden && $store.state.auth.company.account_type !== 2
          && appName !== 'PNDR'"
        class="page-title-area__faq">
        <router-link :to="{ name: 'faq' }">
          <img src="/img/common/icon_faq.png">
        </router-link>
      </div>
      <div
        v-if="!$store.state.isSidebarHidden"
        class="page-title-area__alert"
        :class="{ 'page-title-area__alert--new': $store.state.auth.unread > 0 }">
        <router-link :to="{ name: 'information-index' }">
          <img src="/img/common/icon-alert.png">
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeaderBar',
}
</script>
